export default __webpack_public_path__ + "static/55-b4e4d3c3d54c726c3b8393adef622553.png";